(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["list-filter"] && !Shopify.designMode) return;
  try {
    if (!window.__facetsSwatchTooltipBound) {
    window.__facetsSwatchTooltipBound = true;

    const tooltipClass = 'facets-swatch-tooltip';
    const swatchSelector = '.facets__inputs-list--swatches input[data-swatch-tooltip]';

    let tooltipEl = null;
    let activeInput = null;

    const ensureTooltip = () => {
      if (tooltipEl) return tooltipEl;
      tooltipEl = document.createElement('div');
      tooltipEl.className = tooltipClass;
      tooltipEl.setAttribute('aria-hidden', 'true');
      document.body.appendChild(tooltipEl);
      return tooltipEl;
    };

    const showTooltip = (inputEl, x, y) => {
      const text = inputEl?.dataset?.swatchTooltip;
      if (!text) return;
      activeInput = inputEl;
      const el = ensureTooltip();
      el.textContent = text;
      el.classList.add('is-visible');
      el.style.left = `${x}px`;
      el.style.top = `${y}px`;
    };

    const moveTooltip = (x, y) => {
      if (!tooltipEl || !tooltipEl.classList.contains('is-visible')) return;
      tooltipEl.style.left = `${x}px`;
      tooltipEl.style.top = `${y}px`;
    };

    const hideTooltip = () => {
      activeInput = null;
      if (!tooltipEl) return;
      tooltipEl.classList.remove('is-visible');
    };

    document.addEventListener('pointerenter', (event) => {
      const inputEl = event.target.closest(swatchSelector);
      if (!inputEl) return;
      showTooltip(inputEl, event.clientX, event.clientY - 10);
    }, true);

    document.addEventListener('pointermove', (event) => {
      if (!activeInput) return;
      moveTooltip(event.clientX, event.clientY - 10);
    }, true);

    document.addEventListener('pointerleave', (event) => {
      const inputEl = event.target.closest(swatchSelector);
      if (!inputEl || inputEl !== activeInput) return;
      hideTooltip();
    }, true);

    document.addEventListener('focusin', (event) => {
      const inputEl = event.target.closest(swatchSelector);
      if (!inputEl) return;
      const rect = inputEl.getBoundingClientRect();
      showTooltip(inputEl, rect.left + rect.width / 2, rect.top - 8);
    });

    document.addEventListener('focusout', (event) => {
      const inputEl = event.target.closest(swatchSelector);
      if (!inputEl || inputEl !== activeInput) return;
      hideTooltip();
    });
  }
  } catch(e) { console.error(e); }
})();

})();
